import { REQUEST_ERRORS, REQUEST_ERROR_TYPES } from '../constants/services/request.constants';

export class RequestError extends Error {
  public type: REQUEST_ERROR_TYPES;
  public statusCode: number;

  constructor(type: REQUEST_ERROR_TYPES | number) {
    const processedType = type in REQUEST_ERRORS ? type : REQUEST_ERROR_TYPES.DEFAULT;
    super(REQUEST_ERRORS[processedType].message);

    this.statusCode = REQUEST_ERRORS[processedType].statusCode;
  }
}
